module.exports = __webpack_public_path__ + "img/wt5.e97d5e3d.png";